const map = {
  ACTIVE: "bms-badge-success",
  INACTIVE: "bms-badge-muted",
  OPEN: "bms-badge-success",
  CLOSED: "bms-badge-muted",
  COMPLETED: "bms-badge-success",
  CANCELLED: "bms-badge-danger",
  PENDING: "bms-badge-warning",
  PENDING_APPROVAL: "bms-badge-warning",
  CHANGES_REQUESTED: "bms-badge-warning",
  APPROVED: "bms-badge-success",
  PLACED: "bms-badge-success",
  RECEIVED: "bms-badge-success",
  REJECTED: "bms-badge-danger",
  CORRECTION_REQUESTED: "bms-badge-warning",
  CORRECTED: "bms-badge-info",
  LOW_STOCK: "bms-badge-danger",
  CASH: "bms-badge-info",
  CARD: "bms-badge-info",
  BOTTLE: "bms-badge-info",
  BITE: "bms-badge-warning",
  D: "bms-badge-muted",
  O: "bms-badge-muted",
};

const labels = {
  DRAFT: "Draft",
  PENDING_APPROVAL: "Pending Approval",
  CHANGES_REQUESTED: "Changes Requested",
  APPROVED: "Approved",
  PLACED: "Placed",
  RECEIVED: "Received",
  REJECTED: "Rejected",
};

export const StatusBadge = ({ value }) => {
  const cls = map[value] || "bms-badge-muted";
  return <span className={`bms-badge ${cls}`}>{labels[value] || value}</span>;
};
